import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import { checkInDemoHcs } from './hds'

/**
 * @async
 * @description set heartbeatdate for consultation
 * @param {string} consultationId
 * @returns {void}
 */
export const updateHeartBeatDate = async (consultationId: any) => {
    const consultation = await ToktokdocLib.Consultation.findOne(consultationId)
    await consultation.setHeartBeatDate()
}

/**
 * @async
 * @description set isStreamingStetho for consultation
 * @param {boolean} isStreamingStetho
 * @returns {void}
 */
export const setStreamingStetho = async (consultationId: any, isStreamingStetho: any) => {
    const consultation = await ToktokdocLib.Consultation.findOne(consultationId)
    await consultation.setIsStreamingStetho(isStreamingStetho)
}

/**
 * @async
 * @description initiate a demo TLC (without careGiver)
 * @returns {*}
 */
export const initiateDemoTlc = async () => {
    try {
        const currentUser = await ToktokdocLib.Utils.getCurrentUser()
        await checkInDemoHcs(currentUser.objectId)
        return ToktokdocLib.Consultation.initDemoFromRequiredExpert(currentUser.objectId)
    } catch (error) {
        // @ts-expect-error TS(2769) FIXME: No overload matches this call.
        throw new Error(error)
    }
}

/**
 * @description fetch consultation
 * @param {string} consultationId
 * @returns {Consultation|undefined}
 */
export const getConsultation = async (consultationId: any) => {
    if (consultationId) {
        const consultation = await ToktokdocLib.Consultation.instance(consultationId)
        return consultation
    }
    return undefined
}

/**
 * @description fetch consultation invoice
 * @param {string} consultationId
 * @returns {Invoice|undefined}
 */
export const getConsultationInvoice = async (consultationId: any) => {
    if (consultationId) {
        const consultation = await getConsultation(consultationId)
        const invoice = await consultation.getInvoice()
        return invoice
    }
    return undefined
}
